'use strict';
/**
 * Takes an (async) iterable and returns one with each item mapped by the passed
 * function.
 *
 * @template I,O
 * @param {AsyncIterable<I>|Iterable<I>} source
 * @param {function(I):O|Promise<O>} func
 * @returns {AsyncIterable<O>}
 */

const map = async function* (source, func) {
  for await (const val of source) {
    yield func(val);
  }
};

module.exports = map;